/**
 * Phase 1 WebSocket topic vocabulary (Plan 05).
 *
 * Shared across apps/api (hub broadcast site) and apps/web (client receiver)
 * so topic names cannot drift — MED-8 mitigation for the WS boundary.
 *
 * Phase 1 only writes to `system` (force-reload, pong) and `presence`
 * (member online/offline). The other six topics are declared but empty —
 * Phase 2+ adds chore/point/calendar/shopping/achievement/celebration events
 * without expanding this enum.
 *
 * The `system` topic is special: every authenticated client is auto-subscribed
 * to it on connect, and the hub refuses to unsubscribe it. This guarantees
 * D-08 "Tving reload for alle" (admin force-reload) reaches every client.
 */
export const TOPIC_NAMES = [
  'system',
  'presence',
  'chores',
  'points',
  'achievements',
  'celebrations',
  'calendar',
  'shopping',
  'feed',
  'smarthome',
] as const;

export type TopicName = (typeof TOPIC_NAMES)[number];
